import StarIcon from "../Icons/star-icon";
import "../../Stylesheets/tableV2.css";
import Pagination from "../CommonComponents/Pagination";
import { actions } from "./reviewListReducer";
import styles from "./reviews-page.module.css";
import { Fragment, useMemo } from "react";
import ReviewActions from "./ReviewActions";
import Avatar from "../CommonComponents/avatar/Avatar";

const Rating = ({ label, rating }) => {
  const totalStars = 5;
  const filledStarts = rating;

  const filledFill = "#EFB841";
  const filledStroke = "#E2A013";
  const emptyFill = "#D9D9D9";
  const emptyStroke = "#D9D9D9";

  return (
    <div className={styles.singleRatingContainer}>
      <div className={styles.ratingLabel}>{label}:</div>
      <div className={styles.ratingStars}>
        {Array.from({ length: totalStars }).map((_, index) => (
          <StarIcon
            key={index}
            width={16}
            height={16}
            fill={index < filledStarts ? filledFill : emptyFill}
            stroke={index < filledStarts ? filledStroke : emptyStroke}
          />
        ))}
      </div>
    </div>
  );
};

const ReviewItem = ({ review, dispatch }) => {
  return (
    <div className={styles.reviewItemContainer}>
      <ReviewDetails review={review} />

      {review.hasReviewChat && (
        <div className={styles.reviewActionsContainer}>
          <ReviewActions review={review} dispatch={dispatch} />
        </div>
      )}
    </div>
  );
};

export const ReviewList = ({ state, dispatch }) => {
  return (
    <div className={styles.reviewListContainer}>
      {state.processedReviews.length === 0 && (
        <div className={styles.noReviewsContainer}>
          <div className={styles.noReviewsText}>No reviews found</div>
        </div>
      )}
      {state.processedReviews.map((review, index) => (
        <Fragment key={review.key}>
          <ReviewItem review={review} dispatch={dispatch} />
          {index !== state.processedReviews.length - 1 && (
            <div className={styles.reviewDivider} />
          )}
        </Fragment>
      ))}
      <Pagination
        currentPage={state.pageNumber}
        totalPages={state.totalPages}
        pageSize={state.pageSize}
        totalEntries={state.filteredCount}
        showEntriesInfo={false}
        onPageChange={(pageNum) =>
          dispatch({ type: actions.SET_PAGE_NUMBER, pageNumber: pageNum })
        }
      />
    </div>
  );
};

function ReviewDetails({ review }) {
  const reviewRatings = useMemo(() => {
    let ratings = [];
    if (review.orderRating !== null) {
      ratings.push({label: "Order", rating: review.orderRating});
    }
    if (review.driverRating !== null) {
      ratings.push({label: "Driver", rating: review.driverRating});
    }
    if (review.serviceRating !== null) {
      ratings.push({label: "Service", rating: review.serviceRating});
    }
    return ratings;
  }, [review]);


  return (
    <div className={styles.reviewItemDetails}>
      <Avatar name={review.customerName} size={"36px"} />
      <div className={styles.reviewContent}>
        <div className={styles.reviewerInfo}>
          <div className={styles.reviewerInfoContent}>
            <div className={styles.reviewerName}>{review.customerName}</div>
            <div className={styles.reviewMetadata}>
              {review.reviewTimeFormatted}{" "}
              {review.orderNumber && <>
                <span className={styles.reviewMetadataDivider}>•</span>
                Order No: {review.orderNumber}
              </>}
              <span className={styles.reviewMetadataDivider}>•</span>
              Phone: {review.customerPhoneNumber}
              <span className={styles.reviewMetadataDivider}>•</span>
              {review.companyName}
            </div>
          </div>
        </div>
        <div className={styles.ratingsContainer}>
          {reviewRatings.map((rating, index) => (
            <Fragment key={rating.label}>
              {index > 0 && <div className={styles.ratingsDivider} />}
              <Rating label={rating.label} rating={rating.rating} />
            </Fragment>
          ))}
        </div>
        {review.reviewText && (
          <div className={styles.reviewText}>{review.reviewText}</div>
        )}
      </div>
    </div>
  );
}
